<div class="reference-details-container">
  <div class="form-card">
    <div class="form-header">
      <h4>Reference Master</h4>
    </div>

    <form [formGroup]="referenceForm" class="reference-form">
      <div class="form-row">
        <label for="referenceType">Reference Type</label>
        <select
          id="referenceType"
          class="form-select"
          formControlName="referenceType"
          (change)="applyFilter()"
             [(ngModel)]="add.RG_iid"
        >
          <option value="">-- Select Reference Type --</option>
          <option *ngFor="let type of referenceTypes" [value]="type.RG_iid">
            {{ type.RG_Name }}
          </option>
        </select>
      </div>
    </form>

    <div class="top-actions" *ngIf="referenceForm.value.referenceType">
      <button type="button" class="btn btn-primary" (click)="onAddNew()">
        Add New
      </button>
    </div>

    <div *ngIf="isLoading" class="loading-text">Loading reference values...</div>
    <div *ngIf="!isLoading && !filteredReferenceItems.length" class="empty-text">
      No reference values found for the selected type.
    </div>

    <div *ngIf="!isLoading && filteredReferenceItems.length" class="table-wrapper">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Code</th>
            <th>Description</th>
            <th style="width: 180px;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredReferenceItems">
            <td>{{ getCode(item) }}</td>
            <td>{{ getDescription(item) }}</td>
            <td class="action-cell">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onEdit(item)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="onDelete(item)">
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
